import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import AdminDashboard from "./dashboards/AdminDashboard";
import OperatorDashboard from "./dashboards/OperatorDashboard";
import RhinoDashboard from "./dashboards/RhinoDashboard";
import "./App.css";

// protects routes — redirects to login if no token
const ProtectedRoute = ({ element, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const role  = localStorage.getItem("role");

  if (!token) return <Navigate to="/" replace />;
  if (allowedRoles && !allowedRoles.includes(role)) return <Navigate to="/" replace />;

  return element;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        {/* user dashboard */}
        <Route path="/dashboard" element={
          <ProtectedRoute element={<Dashboard />} allowedRoles={["user"]} />
        }/>

        {/* admin dashboard */}
        <Route path="/admin" element={
          <ProtectedRoute element={<AdminDashboard />} allowedRoles={["admin"]} />
        }/>

        {/* operator dashboard */}
        <Route path="/operator" element={
          <ProtectedRoute element={<OperatorDashboard />} allowedRoles={["operator"]} />
        }/>

        {/* rhino dashboard */}
        <Route path="/rhino" element={
          <ProtectedRoute element={<RhinoDashboard />} allowedRoles={["rhino"]} />
        }/>

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;